module.exports = __webpack_public_path__ + "img/site.84c0ae4b.png";